import {_icons as icons} from "@/domain/icon/svg/_icons";
import {_icons as iconsGradient} from "@/domain/icon/svg/gradient/_icons";
import {_icons as iconsButton} from "@/domain/icon/svg/button/_icons";
import {_icons as iconsSocial} from "@/domain/icon/svg/share/_icons";
export const iconsSet = {
   ...icons,
   ...iconsGradient,
    ...iconsButton,
    ...iconsSocial
};